import { useQuery } from "@apollo/client";
import {
  CompanyFilter,
  CompanyMatchFilter,
} from "../../../../../legacy/types/companyFilter";
import { PRODUCT_DETECTIONS_BY_SEGMENT } from "../../../../../apis/companySearch/productDetectionsBySegment";
import { useWorkspaceStore } from "../../../../../store/workspace/WorkspaceStore";
import { COMPANY_SEARCH_CLIENT } from "../../../../../utils/consts";

export interface SegmentProductDetection {
  productId: number;
  hits: number;
  segment?: string | MinMaxSegment;
}

export interface MinMaxSegment {
  min: number;
  max: number;
}

interface ProductDetectionPayload {
  productDetectionsBySegment: SegmentProductDetection[];
}

interface ProductDetectionVariables {
  productIds: number[];
  companyFilters: CompanyFilter;
  lookbackYears: number;
  segment: string;
  installAge: number;
  localizeInstalls?: boolean;
  companyMatchFile?: CompanyMatchFilter;
}

export enum DetectionSegment {
  COUNTRY = "COUNTRY",
  EMPLOYEE = "EMPLOYEE",
  // employees with an 's' is needed for certain queries
  EMPLOYEES = "EMPLOYEES",
  HG_INDUSTRY = "HG_INDUSTRY",
  INDUSTRY = "INDUSTRY",
  INDUSTRY_NAICS = "INDUSTRY_NAICS",
  REGION = "REGION",
  REVENUE = "REVENUE",
}

interface Options {
  productIds: number[];
  companyFilters: CompanyFilter;
  lookBackYears: number;
  segment: DetectionSegment;
  localizeInstalls?: boolean;
}

export function useProductDetectionsBySegment(options: Options) {
  const workspaceWhitespace = useWorkspaceStore(
    (state) => state.draft?.configuration?.whitespace
  );

  const { data, loading } = useQuery<
    ProductDetectionPayload,
    ProductDetectionVariables
  >(PRODUCT_DETECTIONS_BY_SEGMENT, {
    variables: {
      productIds: options.productIds,
      companyFilters: options.companyFilters,
      lookbackYears: options.lookBackYears,
      segment: options.segment,
      installAge: 24, //* Hard coded value per Leo's request
      localizeInstalls: options.localizeInstalls,
      companyMatchFile:
        options.companyFilters?.opportunityType &&
        workspaceWhitespace?.fileId &&
        workspaceWhitespace?.lastMatched
          ? workspaceWhitespace
          : undefined,
    },
    skip: options.productIds.length === 0,
    context: {
      clientName: COMPANY_SEARCH_CLIENT,
    },
  });

  return {
    isLoading: loading,
    productDetectionsBySegmentBreakdown: data?.productDetectionsBySegment || [],
  };
}
